import { FC, ReactNode } from 'react';
import { Card, CardProps, Divider, Stack, StackProps, Typography, TypographyProps } from '@mui/material';

export interface ILightCardWithTitleProps extends Omit<CardProps, 'title'> {
	title: ReactNode;
	actionButton?: ReactNode;
	headerVariant?: 'dark' | 'light';
	headerProps?: StackProps;
	headerTypographyProps?: TypographyProps & { component?: unknown };
	contentProps?: StackProps;
}

export const LightCardWithTitle: FC<ILightCardWithTitleProps> = ({
	title,
	actionButton,
	headerVariant = 'light',
	headerProps: { sx: headerSx, ...headerProps } = {},
	headerTypographyProps: { sx: headerTypographySx, ...headerTypographyProps } = {},
	contentProps: { sx: contentSx, ...contentProps } = {},
	children,
	sx,
	...props
}) => {
	return (
		<Card sx={{ width: 1.0, ...sx }} variant="outlined" {...props}>
			<Stack direction="column" sx={{ height: 1.0 }}>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					sx={{
						minHeight: 48,
						paddingLeft: 6,
						paddingRight: 5,
						paddingY: actionButton ? 0.75 : 1.5,
						backgroundColor: headerVariant === 'dark' ? 'common.black' : undefined,
						color: headerVariant === 'dark' ? 'common.white' : 'common.black',
						boxSizing: 'content-box',
						...headerSx
					}}
					{...headerProps}
				>
					<Typography sx={{ ...headerTypographySx }} {...headerTypographyProps}>
						{title}
					</Typography>
					{actionButton}
				</Stack>
				<Divider light />
				<Stack sx={{ paddingX: 6, paddingTop: 1, paddingBottom: 2, flexGrow: 1.0, ...contentSx }} {...contentProps}>
					{children}
				</Stack>
			</Stack>
		</Card>
	);
};
